import React, { useState, useEffect } from "react";
import TrashIcon from "@mui/icons-material/DeleteRounded";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-hot-toast";
import AdminDetails from "./adminDetail";
import {
    fetchAdmins,
    inviteAdmin,
    deleteAdmin,
    updateAdmin,
} from 'js/Api/index';
import { Button } from '../Component/CommonFormEle';

function AdminList({ isSuperAdmin }) {
    const [admins, setAdmins] = useState([]);
    const [showInviteModal, setShowInviteModal] = useState(false);
    const [newAdmin, setNewAdmin] = useState({
        name: "",
        email: "",
        isSuperAdmin: false,
    });
    const [emailError, setEmailError] = useState("");
    const [deleteAdminId, setDeleteAdminId] = useState(null);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [editedAdmin, setEditedAdmin] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        loadAdmins();
    }, []);

    const loadAdmins = async () => {
        const result = await fetchAdmins();
        if (result.success) {
            const adminsWithStatus = result.data.map((admin) => {
                const passwordHash = admin.passwordHash || "";
                const status = passwordHash ? "active" : "pending";
                return { ...admin, status };
            });
            setAdmins(adminsWithStatus);
        } else {
            console.error("Failed to fetch admins:", result.error);
        }
    };

    const handleInviteClick = () => {
        if (isSuperAdmin) {
            setShowInviteModal(true);
        }
    };

    const handleAdminInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setNewAdmin({
            ...newAdmin,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleInviteSubmit = async (e) => {
        e.preventDefault();
        if (isSuperAdmin) {
            if (!newAdmin.email.includes("@")) {
                setEmailError("Please enter a valid email address");
                return;
            }
            setEmailError("");

            const result = await inviteAdmin({
                name: newAdmin.name,
                email: newAdmin.email,
                isSuperAdmin: newAdmin.isSuperAdmin,
            });

            if (result.success) {
                setAdmins([...admins, result.data]);
                setShowInviteModal(false);
                toast.success(result.message);
                loadAdmins();
            } else {
                toast.error(result.error);
            }
        }
    };

    const handleInviteCancel = () => {
        setShowInviteModal(false);
    };

    const handleDeleteAdminClick = (userId) => {
        if (isSuperAdmin) {
            setDeleteAdminId(userId);
            setShowDeleteModal(true);
        }
    };

    const handleDeleteAdminConfirm = async () => {
        if (isSuperAdmin && deleteAdminId) {
            const result = await deleteAdmin(deleteAdminId);

            if (result.success) {
                const updatedAdmins = admins.filter(
                    (admin) => admin.userId !== deleteAdminId
                );
                setAdmins(updatedAdmins);
                setDeleteAdminId(null);
                setShowDeleteModal(false);
                toast.success(result.message);
            } else {
                toast.error(result.message);
            }
        }
    };

    const handleDeleteAdminCancel = () => {
        setDeleteAdminId(null);
        setShowDeleteModal(false);
    };

    const handleAdminClick = (admin) => {
        if (isSuperAdmin) {
            setSelectedAdmin(admin);
            setEditedAdmin(admin);
        }
    };

    const handleBackClick = () => {
        setSelectedAdmin(null);
        setEditedAdmin(null);
    };

    const handleEditAdminInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditedAdmin({
            ...editedAdmin,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleEditAdminSubmit = async () => {
        if (isSuperAdmin && editedAdmin) {
            const result = await updateAdmin(editedAdmin.userId, editedAdmin);

            if (result.success) {
                const updatedAdmins = admins.map((admin) =>
                    admin.id === editedAdmin.userId ? editedAdmin : admin
                );
                setAdmins(updatedAdmins);
                setSelectedAdmin(null);
                setEditedAdmin(null);
                toast.success(result.message);
                loadAdmins();
            } else {
                toast.error(result.message);
            }
        }
    };

    if (selectedAdmin) {
        return (
            <AdminDetails
                admin={selectedAdmin}
                editedAdmin={editedAdmin}
                onBackClick={handleBackClick}
                onEditAdminInputChange={handleEditAdminInputChange}
                onEditAdminSubmit={handleEditAdminSubmit}
                isSuperAdmin={isSuperAdmin}
            />
        );
    }

    return (
        <div className="midde_cont">
            <div className="container-fluid">
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title">
                            <h2>Admins</h2>
                        </div>
                    </div>
                </div>
                <div class="white_shd full margin_bottom_30">
                    <div className="full inner_elements">
                        <div className="tabbar padding_infor_info">
                            <Button onClick={handleInviteClick} variant="action-popup" disabled={!isSuperAdmin}>
                                Invite Admin +
                            </Button>
                            <div class="clear"></div>
                            <br />
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="table-wrap">
                                        <table className="table table-responsive-xl table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th style={{ textAlign: "center", alignContent: "center" }}>
                                                        Can add/remove admins
                                                    </th>
                                                    <th>Status</th>
                                                    {isSuperAdmin && <th>&nbsp;</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {admins.map((admin) => (
                                                    <tr key={admin.id} onClick={() => handleAdminClick(admin)}>
                                                        <td>{admin.name}</td>
                                                        <td>{admin.email}</td>
                                                        <td
                                                            style={{ textAlign: "center", alignContent: "center" }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={admin.isSuperAdmin}
                                                                readOnly
                                                            />
                                                        </td>

                                                        <td className="status">
                                                            {admin.passwordHash ? (
                                                                <span className="active">{admin.status}</span>
                                                            ) : (
                                                                <span className="waiting">{admin.status}</span>
                                                            )}
                                                        </td>
                                                        {isSuperAdmin && (
                                                            <td>
                                                                <TrashIcon
                                                                    sx={{
                                                                        fontSize: "1.5rem",
                                                                        color: "black",
                                                                        marginRight: "10px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleDeleteAdminClick(admin.userId);
                                                                    }}
                                                                />
                                                                <EditIcon
                                                                    sx={{
                                                                        fontSize: "1.5rem",
                                                                        color: "black",
                                                                        marginRight: "10px",
                                                                        cursor: "pointer",
                                                                    }}
                                                                />
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showInviteModal && (
                    <div className="modal">
                        <div className="modal-content" style={{ width: "400px" }}>
                            <div className="modal-header">
                                <h1>Invite Admin</h1>
                                <Button onClick={handleInviteCancel} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <form className="contact-form">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="name"
                                        value={newAdmin.name}
                                        onChange={handleAdminInputChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        name="email"
                                        value={newAdmin.email}
                                        onChange={handleAdminInputChange}
                                    />
                                    {emailError && (
                                        <div className="error-message" style={{ color: "red" }}>
                                            {emailError}
                                        </div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label>
                                        <input
                                            className="form-checkbox"
                                            type="checkbox"
                                            name="isSuperAdmin"
                                            checked={newAdmin.isSuperAdmin}
                                            onChange={handleAdminInputChange}
                                        />
                                        &nbsp;Can create admins
                                    </label>
                                </div>
                                <div className="modal-footer">
                                    <Button onClick={handleInviteCancel} variant="cancel">
                                        Cancel
                                    </Button>
                                    <Button onClick={handleInviteSubmit} variant="blue">
                                        Invite
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
                {showDeleteModal && (
                    <div
                        className="modal fade show"
                        style={{ display: "block" }}
                        aria-modal="true"
                        role="dialog"
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title">Delete Admin</h1>
                                    <Button onClick={handleDeleteAdminCancel} variant="modal-close">
                                        &times;
                                    </Button>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        Are you sure you want to delete{" "}
                                        <strong>
                                            {
                                                admins.find((admin) => admin.userId === deleteAdminId)
                                                    ?.name
                                            }
                                        </strong>
                                        ?
                                    </p>
                                </div>
                                <div className="modal-footer">
                                    <Button onClick={handleDeleteAdminCancel} variant="cancel">
                                        Cancel
                                    </Button>
                                    <Button onClick={handleDeleteAdminConfirm} variant="delete">
                                        Delete
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AdminList;
